import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

/**
 * Multi-select category picker grouped by theme. Uses /api/profiles/categories
 * catalog. Selected slugs are lifted up via `onChange(slugsArray)`.
 */
export default function CategoryPicker({ value = [], onChange, testid = "category-picker", max = 15 }) {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    api.get("/profiles/categories").then((r) => setGroups(r.data || [])).catch(() => {});
  }, []);

  const toggle = (slug) => {
    const selected = value.includes(slug);
    let next;
    if (selected) {
      next = value.filter((v) => v !== slug);
    } else {
      if (value.length >= max) return;
      next = [...value, slug];
    }
    onChange && onChange(next);
  };

  if (!groups.length) return null;

  return (
    <div className="flex flex-col gap-4" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="overline" style={{ color: "var(--brand-primary)" }}>Categorías</div>
        <span className="text-xs" style={{ color: "var(--text-muted)" }} data-testid={`${testid}-count`}>
          {value.length}/{max} seleccionadas
        </span>
      </div>

      {groups.map((g) => (
        <div key={g.slug} data-testid={`${testid}-group-${g.slug}`}>
          <div
            className="text-[10px] uppercase tracking-[0.2em] mb-2"
            style={{ color: "var(--text-muted)" }}
          >
            {g.label}
          </div>
          <div className="flex flex-wrap gap-2">
            {g.items.map((cat) => {
              const selected = value.includes(cat.slug);
              return (
                <button
                  key={cat.slug}
                  type="button"
                  onClick={() => toggle(cat.slug)}
                  className="text-xs px-3 py-2 inline-flex items-center gap-1.5 transition-all"
                  style={{
                    background: selected ? "var(--brand-primary)" : "transparent",
                    color: selected ? "#fff" : "var(--text-secondary)",
                    border: `1px solid ${selected ? "var(--brand-primary)" : "var(--border-accent)"}`,
                  }}
                  data-testid={`${testid}-opt-${cat.slug}`}
                >
                  {selected && <Check size={10} strokeWidth={2} />}
                  {cat.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
